import React from 'react';

import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';

import {AuthContext} from './context/AuthContext';
import authProvider from './actions/authProvider';

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<React.StrictMode>
  <AuthContext.Provider value={authProvider}>
    <App />
  </AuthContext.Provider>
</React.StrictMode>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
